import { IconCircles, IconFolder } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon } from '@rossum/ui/material';
import Stats, { StatsType } from '../components/Stats';

type UserStatsProps = {
  user: {
    queuesCount: number;
    workspacesCount: number;
  };
};

const iconProps = {
  color: 'primary',
  sx: { fill: 'none' },
} as const;

export const UserStats = ({
  user: { queuesCount, workspacesCount },
}: UserStatsProps) => {
  const stats: StatsType[] = [
    {
      value: workspacesCount,
      icon: <SvgIcon {...iconProps} component={IconCircles} />,
      title: 'containers.settings.stats.user.activeWorkspaces' as const,
      type: 'workspaces',
    },
    {
      value: queuesCount,
      icon: <SvgIcon {...iconProps} component={IconFolder} />,
      title: 'containers.settings.stats.user.assignedQueues' as const,
      type: 'queues',
    },
  ];

  return (
    <Stack
      direction="row"
      spacing={2}
      useFlexGap
      sx={{ my: 2, flexWrap: 'wrap' }}
    >
      <Stats stats={stats} />
    </Stack>
  );
};
